// Merged English dictionary (French string → English). Each admin page owns a
// fragment file so parallel translation work never collides here. Add a new
// import + spread when adding a page fragment.
import common from './common';
import layout from './layout';
import dashboard from './dashboard';
import orders from './orders';
import orderDetail from './orderDetail';
import covers from './covers';
import layouts from './layouts';
import delivery from './delivery';
import followup from './followup';
import impression from './impression';
import stock from './stock';
import accounting from './accounting';
import customers from './customers';
import settings from './settings';
import assistant from './assistant';
import patch1015 from './patch1015';
import patch1030 from './patch1030';
import editShadow from './editShadow';
import previewSpeed from './previewSpeed';
import workbench from './workbench';
import checkout from './checkout';
import clientRequests from './clientRequests';
import paymentRequest from './paymentRequest';
import processEditor from './process';
import chatPins from './chatPins';
import home from './home';
import aiCosts from './aiCosts';
import aiProviders from './aiProviders';

export const EN: Record<string, string> = {
  ...common,
  ...layout,
  ...dashboard,
  ...orders,
  ...orderDetail,
  ...covers,
  ...layouts,
  ...delivery,
  ...followup,
  ...impression,
  ...stock,
  ...accounting,
  ...customers,
  ...settings,
  ...processEditor,
  ...assistant,
  ...patch1015,
  ...patch1030,
  ...editShadow,
  ...previewSpeed,
  ...workbench,
  ...checkout,
  ...clientRequests,
  ...paymentRequest,
  ...chatPins,
  ...home,
  ...aiCosts,
  ...aiProviders,
};
